import React, { useState, ChangeEvent, FormEvent, useEffect } from "react";
import { motion } from "framer-motion";
import {
  FaHome,
  FaPlus,
  FaSignOutAlt,
  FaBars,
  FaTimes,
  FaArrowLeft,
  FaNewspaper,
  FaQuestion,
  FaSpeakap,
  FaBox,
} from "react-icons/fa";
import useScrollToTop from "../../../components/useScrollToTop";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../../assets/img/rsilogo.png";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/Store";
import { useAppDispatch } from "../../../redux/hooks";
// import { fetchItems } from "../../../redux/slices/AllItemSlice";
import { database, storage } from "../../../appWrite";
import { fetchPosts } from "../../../redux/slices/AllPostSlice";
import BottomNavbar from "../../../components/BottomNavbar";
import FAQModal from "./components/FAQModal";
import TestimonialModal from "./components/TestimonialModal";
import EditFAQModal from "./components/EditFAQModal";
import { fetchFAQs } from "../../../redux/slices/FaqSlice";
import FAQDeleteModal from "./components/FAQDeleteModal";
import TestimonialsDeleteModal from "./components/TestimonialDeleteModal";
import { fetchTestimonials } from "../../../redux/slices/TestimonialSlice";
import TestimonialEditModal from "./components/TestimonialEditModal";
import ProductDeleteModal from "./components/ProductDeleteModal";
import ProductEditModal from "./components/ProductEditModal";
import { fetchItems } from "../../../redux/slices/AllItemSlice";

type Property = {
  id: string;
  title: string;
  content: string;
};

const AdminDashboard: React.FC = () => {
  useScrollToTop();
  const State = useSelector((state: RootState) => state);
  const { posts: allPosts } = State.AllPost;
  const { faqs: allFaqs } = State.Faq;
  const { testimonials: allTestimonials } = State.Testimonial;
  const { allItems: allProducts } = State.AllItem;
  const profile = State.Profile;

  const dispatch = useAppDispatch();

  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isTestimonialModalOpen, setIsTestimonialModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(false);
  const [showEditModal, setShowEditModal] = useState<boolean>(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] =
    useState<boolean>(false);
  const [showAddModal, setShowAddModal] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<{
    id: string;
    image: string;
  }>({ id: "", image: "" });
  const [productToDelete, setProductToDelete] = useState<{
    id: string;
    images: string[];
  }>({ id: "", images: [] });
  const [isTestimonialEditModalOpen, setIsTestimonialEditModalOpen] =
    useState(false);
  const [isProductEditModalOpen, setIsProductEditModalOpen] = useState(false);
  const [testimonialToEdit, setTestimonialToEdit] = useState<any>(null);
  const [productToEdit, setProductToEdit] = useState<any>(null);
  const [testimonialToDelete, setTestimonialToDelete] = useState<{
    id: string;
    image: string;
  }>({ id: "", image: "" });
  const [isFAQDeleteModalOpen, setIsFAQDeleteModalOpen] = useState(false);
  const [isProductDeleteModalOpen, setIsProductDeleteModalOpen] =
    useState(false);
  const [isTestimonialDeleteModalOpen, setIsTestimonialDeleteModalOpen] =
    useState(false);
  const [faqToDelete, setFaqToDelete] = useState<string | null>(null);
  const [editFormData, setEditFormData] = useState<Property>({
    id: "",
    title: "",
    content: "",
  });
  const [showAddProductModal, setShowAddProductModal] = useState(false);
  const [showEditfAQModal, setshowEditfAQModal] = useState(false);

  const [editFAQFormData, setEditFAQFormData] = useState<{
    id: string;
    question: string;
    answer: string;
  } | null>(null);

  type NewProductForm = {
    title: string;
    images: FileList | null;
    description: string;
  };

  // Define initial form state
  const initialProductFormState = {
    title: "",
    description: "",
    images: null,
  };

  const [newProductForm, setNewProductForm] = useState<NewProductForm>({
    title: "",
    images: null, // Use FileList or null to handle multiple images
    description: "",
  });

  // Verify admin access
  useEffect(() => {
    if (!profile || profile.length < 1 || profile[0].role !== "admin") {
      // Navigate to the homepage if the user is not an admin
      navigate("/");
    }
  }, [profile, navigate]);

  type NewBlogPostForm = {
    title: string;
    author: string;
    content: string;
    image: File | null; // Changed from FileList | null to File | null
    category: string;
  };

  // Define initial form state
  const initialFormState = {
    title: "",
    author: "",
    content: "",
    image: null,
    category: "",
  };

  const [newBlogPostForm, setNewBlogPostForm] = useState<NewBlogPostForm>({
    title: "",
    author: "",
    content: "",
    image: null,
    category: "",
  });

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleInputChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setEditFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAddModalOpen = () => {
    setShowAddModal(true);
  };

  const handleAddProductModalOpen = () => {
    setShowAddProductModal(true);
  };

  const handleNewProductInputChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value, files } = e.target as HTMLInputElement;

    if (name === "images" && files) {
      setNewProductForm({
        ...newProductForm,
        images: files,
      });
    } else {
      setNewProductForm({
        ...newProductForm,
        [name]: value,
      });
    }
  };

  const handleNewBlogPostInputChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value, type } = e.target;

    if (type === "file") {
      const fileInput = e.target as HTMLInputElement;
      const selectedFile = fileInput.files?.[0] || null; // Ensure it handles null properly

      setNewBlogPostForm((prevForm) => ({
        ...prevForm,
        [name]: selectedFile, // Store the single file instead of FileList
      }));
    } else {
      setNewBlogPostForm((prevForm) => ({
        ...prevForm,
        [name]: value,
      }));
    }
  };

  const databaseId = "67ce8a4a0032e13c6368"; // Your Appwrite Database ID
  const collectionId = "67d139a9000478a4ce8f"; // Your Appwrite Collection ID

  // Update Item
  const handleFormSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const updateData = {
        title: editFormData.title,
        content: editFormData.content,
        // Add other fields you need to update here
      };

      // Update the item in Appwrite
      await database.updateDocument(
        databaseId,
        collectionId,
        editFormData.id,
        updateData
      );

      alert("Item updated successfully!");

      // Fetch updated items after successful update
      dispatch(fetchPosts());

      setIsLoading(false);
      setShowEditModal(false); // Close the modal
    } catch (error) {
      console.error("Error updating the item:", error);
      setIsLoading(false);
      alert("There was an error updating the item. Please try again.");
    }
  };

  // Create Product
  const handleAddNewProductSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const imageUrls: string[] = []; // Store the URLs of uploaded images

      // Upload the secondary images
      if (newProductForm.images) {
        for (let i = 0; i < newProductForm.images.length; i++) {
          const file = newProductForm.images[i];
          const response = await storage.createFile(
            "67d13a3c002fd583a14b", // Your bucket ID
            "unique()", // Generate a unique file ID
            file, // The file itself
            [] // Optional: specify permissions
          );

          // Retrieve the file's URL
          const fileUrl = await storage.getFileView(
            "67d13a3c002fd583a14b", // Your bucket ID
            response.$id // File ID returned by createFile
          );
          imageUrls.push(fileUrl); // Store the file's URL
        }
      }

      // Prepare property data with image URLs
      const propertyData = {
        title: newProductForm.title,
        description: newProductForm.description,
        image: imageUrls, // Use uploaded image URLs
      };

      // Submit property data to the database
      await database.createDocument(
        databaseId, // Your database ID
        "67dd738c000eb29fbaaf", // Your collection ID
        "unique()", // Unique document ID
        propertyData,
        [] // Optional: specify permissions
      );

      alert("Item added!");
      setIsLoading(false);
      // dispatch(fetchItems());
      setShowAddProductModal(false);
      // Reset form to initial values
      setNewProductForm(initialProductFormState);
      dispatch(fetchItems());
    } catch (error) {
      console.error("There was an error uploading the images:", error);
      setIsLoading(false);
      alert("There was an error adding the item. Please try again.");
    }
  };

  // Create Blog Post
  const handleAddBlogPostSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      let imageUrl = ""; // Store the URL of the uploaded image

      // Upload the blog post image if exists
      if (newBlogPostForm.image) {
        const response = await storage.createFile(
          "67d13a3c002fd583a14b", // Your bucket ID
          "unique()", // Generate a unique file ID
          newBlogPostForm.image // The selected image file
        );

        // Retrieve the file's URL
        imageUrl = storage.getFileView(
          "67d13a3c002fd583a14b", // Your bucket ID
          response.$id // File ID returned by createFile
        );
      }

      // Prepare blog post data
      const blogPostData = {
        title: newBlogPostForm.title,
        content: newBlogPostForm.content,
        image: imageUrl, // Uploaded image URL
        author: newBlogPostForm.author,
        category: newBlogPostForm.category,
        createdAt: new Date().toISOString(),
      };

      // Submit blog post data to the Appwrite database
      await database.createDocument(
        databaseId, // Your database ID
        collectionId, // Your collection ID
        "unique()", // Unique document ID
        blogPostData
      );

      alert("Blog post added successfully!");
      dispatch(fetchPosts());
      setIsLoading(false);
      setShowAddModal(false);
      setNewBlogPostForm(initialFormState); // Reset form to initial values
    } catch (error) {
      console.error("Error adding blog post:", error);
      setIsLoading(false);
      alert("There was an error adding the blog post. Please try again.");
    }
  };

  const handleItemDelete = async () => {
    if (!itemToDelete.id) {
      alert("Error: No item selected for deletion.");
      return;
    }

    console.log("Attempting to delete item with ID:", itemToDelete.id);

    setIsLoading(true);
    let isMounted = true; // Prevents updating state if unmounted

    try {
      const { id, image } = itemToDelete;

      // Delete the image if it exists
      if (image) {
        try {
          const url = new URL(image); // Convert to URL object
          const imagePathParts = url.pathname.split("/"); // Split the path
          const imageId = imagePathParts[imagePathParts.length - 2]; // Get file ID

          if (imageId) {
            await storage.deleteFile("67d13a3c002fd583a14b", imageId);
            console.log(`Deleted image with ID: ${imageId}`);
          } else {
            console.warn("Could not extract file ID from image URL.");
          }
        } catch (error) {
          console.error(`Error deleting image:`, error);
        }
      }

      // Delete the document from the database
      await database.deleteDocument(databaseId, collectionId, id);
      console.log(`Deleted document with ID: ${id}`);

      if (isMounted) {
        alert("Item deleted!");
        setShowDeleteConfirmation(false);
        setItemToDelete({ id: "", image: "" });
        dispatch(fetchPosts()); // Refresh items
      }
    } catch (error: any) {
      console.error("Error:", error);
      if (error.code === 404) {
        alert("Item not found. It may have already been deleted.");
      } else {
        alert("There was an error deleting the item. Please try again.");
      }
    } finally {
      if (isMounted) {
        setIsLoading(false);
      }
    }

    return () => {
      isMounted = false; // Cleanup function to prevent state updates on unmounted components
    };
  };

  const handleProductDelete = async () => {
    if (!productToDelete.id) {
      alert("Error: No item selected for deletion.");
      return;
    }

    console.log("Attempting to delete item with ID:", productToDelete.id);

    setIsLoading(true);
    let isMounted = true; // Prevents updating state if unmounted

    try {
      const { id, images } = productToDelete;

      // Delete each image if it exists
      if (images && images.length > 0) {
        for (const imageUrl of images) {
          try {
            const url = new URL(imageUrl); // Convert to URL object
            const imagePathParts = url.pathname.split("/"); // Split the path
            const imageId = imagePathParts[imagePathParts.length - 2]; // Get file ID

            if (imageId) {
              await storage.deleteFile("67d13a3c002fd583a14b", imageId);
              console.log(`Deleted image with ID: ${imageId}`);
            } else {
              console.warn(
                "Could not extract file ID from image URL:",
                imageUrl
              );
            }
          } catch (error) {
            console.error(`Error deleting image:`, error);
          }
        }
      }

      // Delete the document from the database
      await database.deleteDocument(databaseId, "67dd738c000eb29fbaaf", id);
      console.log(`Deleted document with ID: ${id}`);

      if (isMounted) {
        alert("Item deleted!");
        setIsProductDeleteModalOpen(false);
        setProductToDelete({ id: "", images: [] });
        dispatch(fetchItems()); // Refresh items
      }
    } catch (error: any) {
      console.error("Error:", error);
      if (error.code === 404) {
        alert("Item not found. It may have already been deleted.");
      } else {
        alert("There was an error deleting the item. Please try again.");
      }
    } finally {
      if (isMounted) {
        setIsLoading(false);
      }
    }

    return () => {
      isMounted = false; // Cleanup function to prevent state updates on unmounted components
    };
  };

  const handleDeleteTestimonial = async () => {
    if (!testimonialToDelete.id) {
      alert("Error: No item selected for deletion.");
      return;
    }

    setIsLoading(true);
    let isMounted = true; // Prevents updating state if unmounted

    try {
      const { id, image } = testimonialToDelete;

      // Delete the image if it exists
      if (image) {
        try {
          const url = new URL(image); // Convert to URL object
          const imagePathParts = url.pathname.split("/"); // Split the path
          const imageId = imagePathParts[imagePathParts.length - 2]; // Get file ID

          if (imageId) {
            await storage.deleteFile("67d13a3c002fd583a14b", imageId);
            console.log(`Deleted image with ID: ${imageId}`);
          } else {
            console.warn("Could not extract file ID from image URL.");
          }
        } catch (error) {
          console.error(`Error deleting image:`, error);
        }
      }

      // Delete the document from the database
      await database.deleteDocument(databaseId, "67d7eb5a0013791e9da4", id);
      console.log(`Deleted document with ID: ${id}`);

      if (isMounted) {
        alert("Item deleted!");
        setIsTestimonialDeleteModalOpen(false);
        setTestimonialToDelete({ id: "", image: "" });
        dispatch(fetchTestimonials()); // Refresh items
      }
      setIsLoading(false);
    } catch (error: any) {
      console.error("Error:", error);
      if (error.code === 404) {
        alert("Item not found. It may have already been deleted.");
      } else {
        alert("There was an error deleting the item. Please try again.");
      }
    } finally {
      if (isMounted) {
        setIsLoading(false);
      }
    }

    return () => {
      isMounted = false; // Cleanup function to prevent state updates on unmounted components
    };
  };

  const handleDeleteFAQ = async () => {
    if (!faqToDelete) return;
    setIsLoading(true);

    try {
      await database.deleteDocument(
        "67ce8a4a0032e13c6368",
        "67d7ec6f0022005176aa",
        faqToDelete
      );
      alert("FAQ deleted successfully!");
      dispatch(fetchFAQs()); // Refresh FAQs
      setIsLoading(false);
    } catch (error) {
      console.error("Error deleting FAQ:", error);
    } finally {
      setIsFAQDeleteModalOpen(false);
      setFaqToDelete(null);
    }
  };

  const logoutHandler = () => {
    if (window.confirm("Log out?")) {
      // Assuming removeProfile is imported or defined somewhere else
      // dispatch(removeProfile());
      navigate("/");
    }
  };

  return (
    <>
      {!profile ? (
        <motion.div
          initial={{
            opacity: 0,
          }}
          animate={{
            opacity: 1,
          }}
          transition={{
            duration: 0.5,
            delay: 0.2,
          }}
          className="text-center bg-gray-700 flex-1 h-screen w-screen content-center mx-auto text-white"
        >
          <div>
            <h2 className="font-semibold text-xl">Please log in or sign up</h2>
            <div className="flex gap-3 my-5 justify-center">
              <Link to={"/login"}>
                <button className="bg-gray-500 rounded hover:bg-gray-600 py-[0.5rem] px-[1.5rem]">
                  Login
                </button>
              </Link>
              <Link to={"/signup"}>
                <button className="bg-gray-500 rounded hover:bg-gray-600 py-[0.5rem] px-[1.5rem]">
                  Sign up
                </button>
              </Link>
            </div>
          </div>
        </motion.div>
      ) : (
        <motion.div
          initial={{
            opacity: 0,
          }}
          animate={{
            opacity: 1,
          }}
          transition={{
            duration: 0.5,
            delay: 0.2,
          }}
          className="flex h-screen bg-gray-800 pb-20"
        >
          {/* Sidebar */}
          <div
            className={`fixed inset-0 z-50 bg-gray-600 lg:bg-gray-50 shadow w-64 lg:ml-[2%] lg:mt-[1.5%] lg:rounded-lg p-6 transition-transform duration-300 ${
              sidebarOpen
                ? "translate-x-0"
                : "-translate-x-full md:translate-x-0"
            }`}
          >
            <h1 className="text-xl pt-6 md:pt-0 md:text-3xl max-[450px]:text-white font-bold mb-10">
              Admin Dashboard
            </h1>
            <ul className="space-y-6">
              <li
                className="flex items-center space-x-3 cursor-pointer bg-gray-800 md:bg-gray-600 text-white py-1 pl-2"
                onClick={() => setSidebarOpen(false)}
              >
                <FaHome />
                <span>Overview</span>
              </li>

              <li
                className="flex items-center space-x-3 cursor-pointer hover:bg-gray-800 lg:text-black md:hover:text-white lg:hover:bg-gray-600 text-white py-0 pl-2"
                onClick={() => {
                  handleAddModalOpen();
                  setSidebarOpen(false);
                }}
              >
                <FaPlus />
                <span>Create New Post</span>
              </li>

              <li
                className="flex items-center space-x-3 cursor-pointer hover:bg-gray-800 lg:text-black md:hover:text-white lg:hover:bg-gray-600 text-white py-0 pl-2"
                onClick={() => {
                  setIsModalOpen(true);
                  setSidebarOpen(false);
                }}
              >
                <FaPlus />
                <span>Create Faq</span>
              </li>

              <li
                className="flex items-center space-x-3 cursor-pointer hover:bg-gray-800 lg:text-black md:hover:text-white lg:hover:bg-gray-600 text-white py-0 pl-2"
                onClick={() => {
                  setIsTestimonialModalOpen(true);
                  setSidebarOpen(false);
                }}
              >
                <FaPlus />
                <span>Create Review</span>
              </li>

              <li
                className="flex items-center space-x-3 cursor-pointer hover:bg-gray-800 lg:text-black md:hover:text-white lg:hover:bg-gray-600 text-white py-0 pl-2"
                onClick={() => {
                  handleAddProductModalOpen();
                  setSidebarOpen(false);
                }}
              >
                <FaPlus />
                <span>Create New Product</span>
              </li>

              <Link to={"/"}>
                <li
                  className="flex items-center space-x-3 mt-4 cursor-pointer text-white lg:text-black md:hover:text-white lg:hover:bg-gray-600 hover:bg-gray-800 py-0 pl-2"
                  onClick={() => setSidebarOpen(false)}
                >
                  <FaArrowLeft />
                  <span>Back Home</span>
                </li>
              </Link>

              {/* <Link to={"/admin-users"}>
                <li className="flex items-center space-x-3 cursor-pointer hover:bg-gray-800 lg:text-black md:hover:text-white lg:hover:bg-gray-600 text-white py-1 pl-2 mt-4">
                  <FaUsers />
                  <span>All Users</span>
                </li>
              </Link> */}

              {/* <li className="flex items-center space-x-3 cursor-pointer hover:bg-gray-800 lg:text-black md:hover:text-white lg:hover:bg-gray-600 text-white py-0 pl-2">
                <FaCreditCard />
                <span>Transactions</span>
              </li> */}
            </ul>
            <div className="pt-4">
              <div
                onClick={logoutHandler}
                className="flex items-center space-x-3 cursor-pointer hover:bg-gray-800 lg:text-black md:hover:text-white lg:hover:bg-gray-600 text-white py-0 pl-2"
              >
                <FaSignOutAlt />
                <span>Logout</span>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="flex-1 overflow-auto md:ml-[20vw] h-[100vh] pb-20 md:pb-0">
            <header className="flex justify-between items-center px-4 py-3 text-white top-0">
              <h1 className="text-lg md:text-2xl font-bold">
                Dashboard Overview
              </h1>
              <button
                className="lg:hidden block text-white text-2xl"
                onClick={toggleSidebar}
              >
                {sidebarOpen ? <FaTimes /> : <FaBars />}
              </button>
            </header>

            <section className="p-8">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 text-center">
                <div className="bg-slate-50 shadow-md rounded-md p-3 md:p-6 items-center">
                  <h2 className="text-xl font-semibold mb-3">Total Posts</h2>
                  <FaNewspaper className="mx-auto text-2xl md:text-4xl mb-1 text-red-500" />
                  <p className="text-2xl md:text-3xl font-bold mt-2">
                    {allPosts?.length}
                  </p>
                </div>
                <div className="bg-slate-50 shadow-md rounded-md p-3 md:p-6 items-center">
                  <h2 className="text-xl font-semibold mb-3">Total FAQs</h2>
                  <FaQuestion className="mx-auto text-2xl md:text-4xl mb-1 text-blue-500" />
                  <p className="text-2xl md:text-3xl font-bold mt-2">
                    {allFaqs?.length}
                  </p>
                </div>
                <div className="bg-slate-50 shadow-md rounded-md p-3 md:p-6 items-center">
                  <h2 className="text-xl font-semibold mb-3">Testimonials</h2>
                  <FaSpeakap className="mx-auto text-2xl md:text-4xl mb-1 text-green-500" />
                  <p className="text-2xl md:text-3xl font-bold mt-2">
                    {allTestimonials?.length}
                  </p>
                </div>
                <div className="bg-slate-50 shadow-md rounded-md p-3 md:p-6 items-center">
                  <h2 className="text-xl font-semibold mb-3">Products</h2>
                  <FaBox className="mx-auto text-2xl md:text-4xl mb-1 text-purple-500" />
                  <p className="text-2xl md:text-3xl font-bold mt-2">
                    {allProducts?.length}
                  </p>
                </div>
              </div>
            </section>

            <section className="p-8">
              <h2 className="text-2xl font-semibold mb-4 text-white">Posts</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mx-5 lg:mx-3">
                {allPosts.map((item) => (
                  <div
                    key={item.$id}
                    className="bg-slate-50 shadow-md rounded-md p-2"
                  >
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-20 md:h-32 object-cover rounded-md mb-4"
                    />
                    <h3 className="text-base font-semibold mb-1">
                      {item.title}
                    </h3>
                    <p className="text-sm mb-1">
                      {item.createdAt?.slice(0, 10)}
                    </p>

                    <div className="flex justify-between">
                      <button
                        onClick={() => {
                          setEditFormData({
                            id: item.$id,
                            title: item.title,
                            content: item.content,
                          });
                          setShowEditModal(true);
                        }}
                        className="bg-green-500 text-white px-4 py-1 rounded-md text-sm"
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => {
                          // setEditFormData(property);
                          setShowDeleteConfirmation(true);
                          setItemToDelete({
                            id: item.$id,
                            image: item.image,
                          });
                        }}
                        className="bg-red-500 text-white px-4 py-1 text-sm rounded-md"
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </section>

            <section className="p-8">
              <h2 className="text-2xl font-semibold mb-4 text-white">FAQs</h2>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-6 lg:mx-3">
                {allFaqs.map((item) => (
                  <div
                    key={item.$id}
                    className="bg-slate-50 shadow-md rounded-md p-2"
                  >
                    <h3 className="text-base font-semibold mb-1">
                      {item.question}
                    </h3>
                    <p className="text-sm mb-2">
                      {item.answer.slice(0, 30)}...
                    </p>

                    <div className="flex gap-2 md:gap-8">
                      <button
                        onClick={() => {
                          setEditFAQFormData({
                            id: item.$id,
                            question: item.question,
                            answer: item.answer,
                          });
                          setshowEditfAQModal(true);
                        }}
                        className="bg-green-500 text-white px-4 py-1 rounded-md text-sm"
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => {
                          setFaqToDelete(item.$id);
                          setIsFAQDeleteModalOpen(true);
                        }}
                        className="bg-red-500 text-white px-4 py-1 text-sm rounded-md"
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </section>

            <section className="p-8">
              <h2 className="text-2xl font-semibold mb-4 text-white">
                Testimonials
              </h2>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-6 lg:mx-3">
                {allTestimonials.map((item) => (
                  <div
                    key={item.$id}
                    className="bg-slate-50 shadow-md rounded-md p-2"
                  >
                    <h3 className="text-base font-semibold mb-1">
                      {item.heading}
                    </h3>
                    <p className="text-sm mb-2">
                      {item.review.slice(0, 30)}...
                    </p>

                    <div className="flex gap-2 md:gap-8">
                      <button
                        onClick={() => {
                          setTestimonialToEdit(item);
                          setIsTestimonialEditModalOpen(true);
                        }}
                        className="bg-green-500 text-white px-4 py-1 rounded-md text-sm"
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => {
                          setIsTestimonialDeleteModalOpen(true);
                          setTestimonialToDelete({
                            id: item.$id,
                            image: item.image,
                          });
                          setIsTestimonialDeleteModalOpen(true);
                        }}
                        className="bg-red-500 text-white px-4 py-1 text-sm rounded-md"
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </section>

            <section className="p-8">
              <h2 className="text-2xl font-semibold mb-4 text-white">
                Products
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mx-5 lg:mx-3">
                {allProducts.map((item) => (
                  <div
                    key={item.id}
                    className="bg-slate-50 shadow-md rounded-md p-2"
                  >
                    <img
                      src={item.images[0]}
                      alt={item.title}
                      className="w-full h-20 md:h-32 object-cover rounded-md mb-4"
                    />
                    <h3 className="text-base font-semibold mb-1">
                      {item.title}
                    </h3>

                    <div className="flex justify-between">
                      <button
                        onClick={() => {
                          setProductToEdit({
                            id: item.id,
                            title: item.title,
                            description: item.description,
                          });
                          setIsProductEditModalOpen(true);
                        }}
                        className="bg-green-500 text-white px-4 py-1 rounded-md text-sm"
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => {
                          // setEditFormData(property);
                          setIsProductDeleteModalOpen(true);
                          setProductToDelete({
                            id: item.id,
                            images: item.images,
                          });
                        }}
                        className="bg-red-500 text-white px-4 py-1 text-sm rounded-md"
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </section>
          </div>
        </motion.div>
      )}
      {/* Modals */}
      {/* Edit Modal */}
      {showEditModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          <div className="bg-white w-[90%] md:w-[30%] p-4 rounded shadow-md">
            <h2 className="text-xl md:text-2xl font-semibold mb-2">
              Edit Item
            </h2>
            <form onSubmit={handleFormSubmit}>
              <label htmlFor="title">Title</label>
              <input
                type="text"
                name="title"
                value={editFormData.title}
                onChange={handleInputChange}
                placeholder="Title"
                className="w-full border border-gray-300 px-4 py-2 rounded mb-4"
              />
              <label htmlFor="content">Content</label>
              <textarea
                rows={9}
                name="content"
                value={editFormData.content}
                onChange={handleInputChange}
                placeholder="Content"
                className="w-full border border-gray-300 px-4 py-2 rounded mb-4"
              />

              <button
                type="submit"
                className="bg-blue-500 text-white px-4 py-1 rounded"
                disabled={isLoading}
              >
                {isLoading ? "Saving..." : "Save Changes"}
              </button>
              <button
                type="button"
                onClick={() => setShowEditModal(false)}
                className="bg-gray-500 text-white px-4 py-1 rounded ml-2"
              >
                Cancel
              </button>
            </form>
          </div>
        </div>
      )}

      {/* Add Modal */}
      {showAddModal && (
        <div className="fixed inset-0 overflow-y-scroll flex items-center justify-center z-50 bg-black bg-opacity-50">
          <div className="bg-white w-[90%] md:w-[40%] p-8 rounded shadow-lg">
            <h2 className="text-2xl font-semibold mb-4">Add New Blog Post</h2>
            <form onSubmit={(e) => handleAddBlogPostSubmit(e)}>
              <input
                type="text"
                name="title"
                value={newBlogPostForm.title}
                onChange={handleNewBlogPostInputChange}
                placeholder="Title"
                className="w-full border border-gray-300 px-4 py-2 rounded mb-4"
                required
              />
              <input
                type="file"
                name="image"
                onChange={handleNewBlogPostInputChange}
                className="w-full border border-gray-300 px-4 py-2 rounded mb-4"
                required
              />
              <textarea
                name="content"
                value={newBlogPostForm.content}
                onChange={handleNewBlogPostInputChange}
                placeholder="Content"
                className="w-full border border-gray-300 px-4 py-2 rounded mb-4 h-40"
                required
              />
              <input
                type="text"
                name="author"
                value={newBlogPostForm.author}
                onChange={handleNewBlogPostInputChange}
                placeholder="Author"
                className="w-full border border-gray-300 px-4 py-2 rounded mb-4"
                required
              />
              <div className="mb-4">
                <label
                  htmlFor="category"
                  className="block text-gray-700 font-medium mb-2"
                >
                  Category
                </label>
                <select
                  id="category"
                  name="category"
                  value={newBlogPostForm.category}
                  onChange={handleNewBlogPostInputChange}
                  className="w-full border border-gray-300 p-2 rounded"
                  required
                >
                  <option value="">Select Category</option>
                  <option value="technology">Technology</option>
                  <option value="business">Business</option>
                  <option value="lifestyle">Lifestyle</option>
                  <option value="health">Health</option>
                </select>
              </div>
              {isLoading ? (
                <img
                  src={logo}
                  className="w-[8rem] bg-white p-6 animate-pulse self-center"
                  alt="Loading"
                />
              ) : (
                <>
                  <button
                    type="submit"
                    className="bg-blue-500 text-white px-4 py-2 rounded"
                  >
                    Add Post
                  </button>
                  <button
                    type="button"
                    onClick={() => setShowAddModal(false)}
                    className="bg-gray-500 text-white px-4 py-2 rounded ml-2"
                  >
                    Cancel
                  </button>
                </>
              )}
            </form>
          </div>
        </div>
      )}

      {/* Delete Confirmation */}
      {showDeleteConfirmation && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          <div className="bg-white w-[90%] md:w-[30%] p-8 rounded shadow-md">
            <h2 className="text-2xl font-semibold mb-4">Confirm Deletion</h2>
            <p>Are you sure you want to delete this Item?</p>
            <div className="flex justify-end mt-4">
              <button
                onClick={() => {
                  handleItemDelete();
                  setIsLoading(true);
                }}
                className="bg-red-500 text-white px-4 py-2 rounded"
                disabled={isLoading}
              >
                {isLoading ? "Deleting..." : "Delete"}
              </button>
              <button
                onClick={() => setShowDeleteConfirmation(false)}
                className="bg-gray-500 text-white px-4 py-2 rounded ml-2"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Add Modal */}
      {showAddProductModal && (
        <div className="fixed inset-0 overflow-y-scroll flex items-center justify-center z-50">
          <div className="bg-white w-[90%] md:w-[30%] p-8 rounded shadow-md">
            <h2 className="text-2xl font-semibold mb-4">Add Product</h2>
            <form onSubmit={(e) => handleAddNewProductSubmit(e)}>
              <input
                type="text"
                name="title"
                value={newProductForm.title}
                onChange={handleNewProductInputChange}
                placeholder="Title"
                className="w-full border border-gray-300 px-4 py-2 rounded mb-4"
              />
              <input
                type="file"
                name="images"
                multiple
                onChange={handleNewProductInputChange}
                className="w-full border border-gray-300 px-4 py-2 rounded mb-4"
              />

              <textarea
                name="description"
                value={newProductForm.description}
                onChange={handleNewProductInputChange}
                placeholder="Description"
                className="w-full border border-gray-300 px-4 py-2 rounded mb-4"
              />

              {isLoading ? (
                <>
                  <img
                    src={logo}
                    className="w-[8rem] bg-white p-6 animate-pulse self-center"
                    alt=""
                  />
                </>
              ) : (
                <>
                  <button
                    type="submit"
                    className="bg-blue-500 text-white px-4 py-2 rounded"
                  >
                    Add Product
                  </button>
                  <button
                    type="button"
                    onClick={() => setShowAddProductModal(false)}
                    className="bg-gray-500 text-white px-4 py-2 rounded ml-2"
                  >
                    Cancel
                  </button>
                </>
              )}
            </form>
          </div>
        </div>
      )}

      <FAQModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
      <TestimonialModal
        isOpen={isTestimonialModalOpen}
        onClose={() => setIsTestimonialModalOpen(false)}
      />
      <EditFAQModal
        isOpen={showEditfAQModal}
        onClose={() => setshowEditfAQModal(false)}
        faqData={editFAQFormData}
      />
      {/* Delete Modal */}
      <FAQDeleteModal
        isOpen={isFAQDeleteModalOpen}
        onClose={() => setIsFAQDeleteModalOpen(false)}
        onDelete={handleDeleteFAQ}
        isLoading={isLoading}
      />

      <TestimonialsDeleteModal
        isOpen={isTestimonialDeleteModalOpen}
        onClose={() => setIsTestimonialDeleteModalOpen(false)}
        onDelete={handleDeleteTestimonial}
      />

      <ProductDeleteModal
        isOpen={isProductDeleteModalOpen}
        onClose={() => setIsProductDeleteModalOpen(false)}
        onDelete={handleProductDelete}
      />

      <TestimonialEditModal
        isOpen={isTestimonialEditModalOpen}
        onClose={() => setIsTestimonialEditModalOpen(false)}
        testimonial={testimonialToEdit}
      />

      <ProductEditModal
        isOpen={isProductEditModalOpen}
        onClose={() => setIsProductEditModalOpen(false)}
        product={productToEdit}
      />
      <BottomNavbar current="profile" />
    </>
  );
};

export default AdminDashboard;
